export default "__VITE_ASSET__BXg$lZdb__"